enum DistributorOrderSkuRoutes {
  List = '/retailer-orders-sku',
  Edit = '/retailer-orders-sku/edit/:id',
  Add = '/retailer-orders-sku/add',
}

export default DistributorOrderSkuRoutes
